import React, { useEffect, useRef } from 'react';

import classes from './logoLoader.module.scss';

export const LogoLoader = () => {
  const svgRef = useRef(null);

  useEffect(() => {
    const legs = svgRef.current.querySelectorAll(`.${classes.stroke}`);

    legs.forEach((path) => {
      const length = path.getTotalLength();

      path.style.setProperty('--dash', length);
    });
  }, []);

  return (
    <div className={classes.logo}>
      <svg
        ref={svgRef}
        width="197"
        height="156"
        viewBox="0 0 197 156"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={`${classes.stroke} ${classes.delay_1}`}
          d="M7.8595 148.454L55.5813 17.7464C56.2218 15.9921 57.1062 14.3368 58.2086 12.8294L58.7116 12.1415C59.1814 11.499 59.7161 10.9064 60.3072 10.3732V10.3732C62.2732 8.5996 64.7862 7.55098 67.4298 7.40111L68.0787 7.36432L69.7423 7.36432C71.0624 7.36433 72.3731 7.58661 73.6194 8.02184V8.02184C75.8952 8.81663 77.8718 10.2916 79.2815 12.2471L80.1859 13.5017C81.0756 14.7358 81.7922 16.086 82.3156 17.5145L120.929 122.89C122.081 126.034 122.463 129.409 122.043 132.732L121.967 133.334C121.796 134.686 121.456 136.01 120.953 137.277L120.91 137.384C120.519 138.369 120.025 139.31 119.437 140.192V140.192C117.419 143.216 114.376 145.41 110.869 146.369L108.197 147.1C106.926 147.448 105.627 147.683 104.316 147.803L100.649 148.14L96.9245 148.034C95.6304 147.997 94.3425 147.841 93.0769 147.569L91.3376 147.195C86.2197 146.095 81.8442 142.707 79.4608 138.046V138.046C78.229 135.637 77.5744 132.948 77.5729 130.242V130.242C77.5718 128.308 77.8987 126.387 78.5397 124.562L90.1513 91.5014"
          stroke="#7833F3"
          strokeWidth="14"
          strokeLinecap="round"
        />

        <path
          className={`${classes.stroke} ${classes.delay_2}`}
          d="M109.276 36.1472L116.772 16.3761C117.911 13.3719 120.037 10.8438 122.801 9.20627L123.102 9.02815C125.333 7.70619 127.908 7.08024 130.497 7.23044V7.23044C132.592 7.35196 134.627 7.97757 136.428 9.05405L136.606 9.16073C139.39 10.8247 141.503 13.4111 142.579 16.4708L144.594 22.2043L189.445 145.49"
          stroke="#7833F3"
          strokeWidth="14"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
